/** Public marketing contact — override via REACT_APP_* at build time. */
export const PUBLIC_SITE_ORIGIN =
  (typeof process !== 'undefined' && process.env.REACT_APP_PUBLIC_SITE_URL) || 'https://sati-architects.com';

export const CONTACT_EMAIL =
  (typeof process !== 'undefined' && process.env.REACT_APP_CONTACT_TO_EMAIL) || 'hello@sati-architects.com';

export const CONTACT_PHONE_DISPLAY =
  (typeof process !== 'undefined' && process.env.REACT_APP_CONTACT_PHONE_DISPLAY) || '+380 (97) 412 91 18';

export const CONTACT_PHONE_TEL =
  (typeof process !== 'undefined' && process.env.REACT_APP_CONTACT_PHONE_RAW) || 'tel:+380974129118';

const tg =
  (typeof process !== 'undefined' && process.env.REACT_APP_CONTACT_TELEGRAM_PUBLIC) || 'dorozhynskyii';
const tgClean = String(tg).replace(/^@/, '');

export const CONTACT_TELEGRAM_USERNAME = tgClean;
export const CONTACT_TELEGRAM_URL = `https://t.me/${tgClean}`;
